$(document).ready(function() {
    const IDENTIFIER = 'tip_report';
    const wrapperId = 'div#' + IDENTIFIER + '_wrapper';
    const pathReport = '/action/report/tip';
    const reportTypeSelectId = 'select#' + IDENTIFIER + '_type';
    const reportTypeSelect = $(reportTypeSelectId);
    const reportContentTypeSelect = $('select#' + IDENTIFIER + '_content_type');
    const reportContentTypeFormGroup = $('div#' + IDENTIFIER + '_content_type_form_group');
    const fetchReportButton = $("div#fetch_" + IDENTIFIER + "_button");
    const reportDataWrapper = $("div#" + IDENTIFIER + "_data_wrapper");
    const pathExcelExportURL = "/action/report/excel/tip-report";

    var ajaxLockActive = false;

    // todo: remove old ajax path when new report is published
    var ajaxPathOld = '/includes/report/ajax.php';

    $(wrapperId).on('change', reportTypeSelectId, function () {
        let reportType = $(this).val();
        if (reportType === 'integrated_bank_terminal') {
            reportContentTypeFormGroup.show();
        } else {
            reportContentTypeFormGroup.hide();
        }
    });

    fetchReportButton.click(function (e) {
        if (ajaxLockActive){
            return false;
        }

        displayLoadingGifInElement(fetchReportButton)
        const data = getDataParameters();
        $.ajax({
            type: 'GET',
            url: pathReport,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            removeLoadingGifFromButton();
            reportDataWrapper.html(data.html);
        }).error(function (response) {
            removeLoadingGifFromButton();
            displayErrorMessage('Kunne ikke hente rapport!', $.parseJSON(response.responseText).errors);
        });
    });

    $(document).on('click', 'div#' + IDENTIFIER + '_data_wrapper a#tip_download_excel_report_button', function () {
        createExcelFile();
        return false;
    });


    function createExcelFile() {
        if (ajaxLockActive) {
            return;
        }
        ajaxLockActive = true;

        $.ajax({
            type: 'GET',
            url: pathExcelExportURL,
            data: getDataParameters(),
            dataType: 'json'
        }).success(function (data) {
            window.location = '/includes/report/excels/' + data.excel_file_name;
        }).error(function (data) {
            // onError($.parseJSON(data.responseText).errors);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getDataParameters() {
        let data = {
            from_date: getDateFrom(),
            to_date: getDateTo(),
            report_type: reportTypeSelect.val()
        };

        if (reportTypeSelect.val() === 'integrated_bank_terminal') {
            data.report_content_type = reportContentTypeSelect.val();
        }
        return data
    }

    function getDateFrom() {
        return $("input#" + IDENTIFIER + "_date_from").val();
    }
    function getDateTo() {
        return $("input#" + IDENTIFIER + "_date_to").val();
    }

    function removeLoadingGifFromButton() {
        fetchReportButton.html("Oppdater");
    }

    function displayErrorMessage(title, errorMessage) {
        let parentElement = $(wrapperId);
        displayInfoMessageModal(parentElement, title, errorMessage, 'Lukk', 'error');
    }

    /*
     * @todo: Old deprecated report, remove when new report is published.....
     * Fetch report
     */
    $(document).on('submit', 'form#tip_report_period_form', function(event) {
        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;
        //Post serialized form and save KundeClass
        $.ajax({
            type: 'POST',
            url: ajaxPathOld,
            data: {
                action: 'get_tip_report',
                params: $('form#tip_report_period_form').serialize()
            }
        }).done(function(response) {
            // Validate response
            var success = true;
            if (response.status === undefined) {
                success = false;
            } else if (response.status.toUpperCase() !== 'OK') {
                success = false;
            }

            if (success) {
                // Success
                $('tbody#tip_report_tbody').html(response.html);
            } else {
                // Display error message and scroll to top of page
                alert('Kunne ikke hente rapport!' + response.error_message);
            }
            ajaxLockActive = false;
        }, 'json');
        return false;
    });
});